(function() {
  var DialogController,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  DialogController = App.loadClass('core::Angular/DialogController');

  exports.SetupDialogController = (function(superClass) {
    extend(SetupDialogController, superClass);

    function SetupDialogController(scope1, transitions, rootScope, repo, loader, $q, state, hooks, modal) {
      var ref, things_to_load;
      this.scope = scope1;
      this.transitions = transitions;
      this.rootScope = rootScope;
      this.repo = repo;
      this.state = state;
      this.modal = modal;
      this.setProductFullNames = bind(this.setProductFullNames, this);
      this.recalculateActiveProducts = bind(this.recalculateActiveProducts, this);
      this.deactivateProduct = bind(this.deactivateProduct, this);
      this.activateProduct = bind(this.activateProduct, this);
      this.editProduct = bind(this.editProduct, this);
      this.addProduct = bind(this.addProduct, this);
      this.loadProducts = bind(this.loadProducts, this);
      this.deleteTreatment = bind(this.deleteTreatment, this);
      this.openTreatmentDialog = bind(this.openTreatmentDialog, this);
      this.editTreatment = bind(this.editTreatment, this);
      this.addTreatment = bind(this.addTreatment, this);
      this.loadTreatments = bind(this.loadTreatments, this);
      this.deleteTraitPackage = bind(this.deleteTraitPackage, this);
      this.openTraitPackageDialog = bind(this.openTraitPackageDialog, this);
      this.editTraitPackage = bind(this.editTraitPackage, this);
      this.addTraitPackage = bind(this.addTraitPackage, this);
      this.loadTraitSuppliers = bind(this.loadTraitSuppliers, this);
      this.loadTraitPackages = bind(this.loadTraitPackages, this);
      this.loadSeedCompanies = bind(this.loadSeedCompanies, this);
      this.showActivationError = bind(this.showActivationError, this);
      this.showLoadingError = bind(this.showLoadingError, this);
      this.showError = bind(this.showError, this);
      SetupDialogController.__super__.constructor.call(this, this.scope, this.transitions);
      this.scope.fullpage = true;
      if (((ref = this.scope.selected.crop) != null ? ref.lineups_id : void 0) == null) {
        this.state.go('portal.ratings.setup');
        return;
      }
      loader.overMap('Loading...');
      things_to_load = [this.loadSeedCompanies(this.scope.selected.crop), this.loadTraitPackages(this.scope.selected.crop), this.loadTraitSuppliers(), this.loadTreatments(this.scope.selected.crop), this.loadProducts(this.scope.selected.crop)];
      $q.all(things_to_load).then((function(_this) {
        return function(result) {
          _this.recalculateActiveProducts();
          _this.setProductFullNames();
          loader.hideAll();
          return typeof hooks.afterLoad === "function" ? hooks.afterLoad(_this.scope) : void 0;
        };
      })(this));
      this.trait_suppliers = [];
      this.scope.seed_companies = [];
      this.scope.trait_packages = [];
      this.scope.treatments = [];
      this.scope.products = [];
      this.scope.show_inactive_products = false;
      this.scope.addTraitPackage = this.addTraitPackage;
      this.scope.editTraitPackage = this.editTraitPackage;
      this.scope.deleteTraitPackage = this.deleteTraitPackage;
      this.scope.addTreatment = this.addTreatment;
      this.scope.editTreatment = this.editTreatment;
      this.scope.deleteTreatment = this.deleteTreatment;
      this.scope.addProduct = this.addProduct;
      this.scope.editProduct = this.editProduct;
      this.scope.deactivateProduct = this.deactivateProduct;
      this.scope.activateProduct = this.activateProduct;
      delete this.scope.cancel;
      delete this.scope.save;
      delete this.cancel;
      delete this.save;
    }

    SetupDialogController.prototype.showError = function(msg) {
      return alert(msg);
    };

    SetupDialogController.prototype.showLoadingError = function(items, msg) {
      if (msg == null) {
        msg = null;
      }
      if (msg != null) {
        msg = "Failed to load " + items + ": " + msg;
      } else {
        msg = "Failed to load " + items;
      }
      return this.showError(msg);
    };

    SetupDialogController.prototype.showActivationError = function(item, activating, msg) {
      var action;
      if (msg == null) {
        msg = null;
      }
      action = activating ? 'activate' : 'deactivate';
      if (msg != null) {
        msg = "Failed to " + action + " " + item + ": " + msg;
      } else {
        msg = "Failed to " + action + " " + item;
      }
      return this.showError(msg);
    };

    SetupDialogController.prototype.loadSeedCompanies = function(crop) {
      var promise;
      promise = this.repo.getSeedCompanies(crop.lineups_id).then((function(_this) {
        return function(response) {
          var ref, ref1;
          if (((ref = response.status) != null ? ref.type : void 0) !== 'success') {
            _this.showLoadingError('Seed Companies', (ref1 = response.status) != null ? ref1.msg : void 0);
            return;
          }
          return _this.scope.seed_companies = response.data.seed_companies;
        };
      })(this))["catch"]((function(_this) {
        return function(response) {
          return _this.showLoadingError('Seed Companies');
        };
      })(this));
      return promise;
    };

    SetupDialogController.prototype.loadTraitPackages = function(crop) {
      var promise;
      promise = this.repo.getTraitPackages(crop.lineups_id).then((function(_this) {
        return function(response) {
          var ref, ref1;
          if (((ref = response.status) != null ? ref.type : void 0) !== 'success') {
            _this.showLoadingError('Trait Packages', (ref1 = response.status) != null ? ref1.msg : void 0);
            return;
          }
          return _this.scope.trait_packages = response.data.trait_packages;
        };
      })(this))["catch"]((function(_this) {
        return function(response) {
          return _this.showLoadingError('Trait Packages');
        };
      })(this));
      return promise;
    };

    SetupDialogController.prototype.loadTraitSuppliers = function() {
      var promise;
      promise = this.repo.getTraitSuppliers().then((function(_this) {
        return function(response) {
          var ref, ref1;
          if (((ref = response.status) != null ? ref.type : void 0) !== 'success') {
            _this.showLoadingError('Trait Suppliers', (ref1 = response.status) != null ? ref1.msg : void 0);
            return;
          }
          _this.trait_suppliers = response.data.trait_suppliers.map(function(trait) {
            trait.is_divider = false;
            return trait;
          });
          return _this.trait_suppliers.push({
            id: -1,
            name: '---------------',
            is_real: false,
            is_divider: true
          });
        };
      })(this))["catch"]((function(_this) {
        return function(response) {
          return _this.showLoadingError('Trait Suppliers');
        };
      })(this));
      return promise;
    };

    SetupDialogController.prototype.addTraitPackage = function() {
      return this.openTraitPackageDialog();
    };

    SetupDialogController.prototype.editTraitPackage = function(trait_package) {
      return this.openTraitPackageDialog(trait_package);
    };

    SetupDialogController.prototype.openTraitPackageDialog = function(trait_package) {
      var dialog;
      if (trait_package == null) {
        trait_package = null;
      }
      dialog = this.modal.open({
        windowClass: 'small_dialog',
        templateUrl: 'backend/portal/ratings/trait-packages/dialog',
        controller: 'Ratings.Controllers.TraitPackageDialogController',
        resolve: {
          'lineups_id': (function(_this) {
            return function() {
              return _this.scope.selected.crop.lineups_id;
            };
          })(this),
          'trait_package': (function(_this) {
            return function() {
              return trait_package;
            };
          })(this),
          'trait_suppliers': (function(_this) {
            return function() {
              return _this.trait_suppliers;
            };
          })(this)
        }
      });
      return dialog.result.then((function(_this) {
        return function(saved_trait_package) {
          if (trait_package != null) {
            $.extend(trait_package, saved_trait_package);
          } else {
            trait_package = _.head(_.filter(_this.scope.trait_packages, {
              name: saved_trait_package.name
            }));
            if (trait_package != null) {
              $.extend(trait_package, saved_trait_package);
            } else {
              _this.scope.trait_packages.push(saved_trait_package);
            }
          }
          _this.recalculateActiveProducts();
          return _this.setProductFullNames();
        };
      })(this));
    };

    SetupDialogController.prototype.deleteTraitPackage = function(trait_package) {
      var del_scope, dialog;
      if (trait_package.num_active > 0) {
        return;
      }
      del_scope = this.scope.$new();
      del_scope.title = 'Delete Trait Package';
      del_scope.item_name = 'Trait Package';
      del_scope["delete"] = (function(_this) {
        return function() {
          return _this.repo.deleteTraitPackage(_this.scope.selected.crop.lineups_id, trait_package);
        };
      })(this);
      dialog = this.modal.open({
        windowClass: 'small_dialog',
        templateUrl: 'backend/portal/ratings/setup/delete-dialog',
        controller: 'DeleteDialogController',
        scope: del_scope
      });
      return dialog.result.then((function(_this) {
        return function() {
          return trait_package.active = false;
        };
      })(this));
    };

    SetupDialogController.prototype.loadTreatments = function(crop) {
      var promise;
      promise = this.repo.getTreatments(crop.lineups_id).then((function(_this) {
        return function(response) {
          var ref, ref1;
          if (((ref = response.status) != null ? ref.type : void 0) !== 'success') {
            _this.showLoadingError('Treatments', (ref1 = response.status) != null ? ref1.msg : void 0);
            return;
          }
          return _this.scope.treatments = response.data.treatments;
        };
      })(this))["catch"]((function(_this) {
        return function(response) {
          return _this.showLoadingError('Treatments');
        };
      })(this));
      return promise;
    };

    SetupDialogController.prototype.addTreatment = function() {
      return this.openTreatmentDialog();
    };

    SetupDialogController.prototype.editTreatment = function(treatment) {
      return this.openTreatmentDialog(treatment);
    };

    SetupDialogController.prototype.openTreatmentDialog = function(treatment) {
      var dialog;
      if (treatment == null) {
        treatment = null;
      }
      dialog = this.modal.open({
        windowClass: 'small_dialog',
        templateUrl: 'backend/portal/ratings/treatments/dialog',
        controller: 'Ratings.Controllers.TreatmentDialogController',
        resolve: {
          'lineups_id': (function(_this) {
            return function() {
              return _this.scope.selected.crop.lineups_id;
            };
          })(this),
          'treatment': (function(_this) {
            return function() {
              return treatment;
            };
          })(this)
        }
      });
      return dialog.result.then((function(_this) {
        return function(saved_treatment) {
          if (treatment != null) {
            $.extend(treatment, saved_treatment);
          } else {
            treatment = _.head(_.filter(_this.scope.treatments, {
              name: saved_treatment.name
            }));
            if (treatment != null) {
              $.extend(treatment, saved_treatment);
            } else {
              _this.scope.treatments.push(saved_treatment);
            }
          }
          return _this.recalculateActiveProducts();
        };
      })(this));
    };

    SetupDialogController.prototype.deleteTreatment = function(treatment) {
      var del_scope, dialog;
      if (treatment.num_active > 0) {
        return;
      }
      del_scope = this.scope.$new();
      del_scope.title = 'Delete Treatment';
      del_scope.item_name = 'Treatment';
      del_scope["delete"] = (function(_this) {
        return function() {
          return _this.repo.deleteTreatment(_this.scope.selected.crop.lineups_id, treatment);
        };
      })(this);
      dialog = this.modal.open({
        windowClass: 'small_dialog',
        templateUrl: 'backend/portal/ratings/setup/delete-dialog',
        controller: 'DeleteDialogController',
        scope: del_scope
      });
      return dialog.result.then((function(_this) {
        return function() {
          return treatment.active = false;
        };
      })(this));
    };

    SetupDialogController.prototype.loadProducts = function(crop) {
      var promise;
      promise = this.repo.getProducts(crop.lineups_id).then((function(_this) {
        return function(response) {
          var ref, ref1;
          if (((ref = response.status) != null ? ref.type : void 0) !== 'success') {
            _this.showLoadingError('Products', (ref1 = response.status) != null ? ref1.msg : void 0);
            return;
          }
          return _this.scope.products = response.data.products;
        };
      })(this))["catch"]((function(_this) {
        return function(response) {
          return _this.showLoadingError('Products');
        };
      })(this));
      return promise;
    };

    SetupDialogController.prototype.addProduct = function() {
      var dialog, scope;
      scope = this.scope.$new(true);
      scope.seed_companies = this.scope.seed_companies;
      scope.trait_packages = this.scope.trait_packages;
      scope.existing_products = this.scope.products;
      scope.addSeedCompany = this.addSeedCompany;
      scope.addTraitPackage = this.addTraitPackage;
      dialog = this.modal.open({
        windowClass: 'product-dialog',
        templateUrl: 'backend/portal/ratings/products/add-dialog',
        controller: 'Ratings.Controllers.AddProductDialogController',
        scope: scope,
        resolve: {
          'lineups_id': (function(_this) {
            return function() {
              return _this.scope.selected.crop.lineups_id;
            };
          })(this)
        }
      });
      return dialog.result.then((function(_this) {
        return function(saved_products) {
          $.merge(_this.scope.products, saved_products);
          _this.recalculateActiveProducts();
          _this.setProductFullNames();
          return _this.rootScope.$broadcast('ratings.add-product:saved', {
            saved_products: saved_products
          });
        };
      })(this), (function(_this) {
        return function() {
          return _this.rootScope.$broadcast('ratings.add-product:cancelled', {});
        };
      })(this));
    };

    SetupDialogController.prototype.editProduct = function(product) {
      var dialog, scope;
      scope = this.scope.$new(true);
      scope.seed_companies = this.scope.seed_companies;
      scope.trait_packages = this.scope.trait_packages;
      scope.existing_products = this.scope.products;
      scope.addSeedCompany = this.addSeedCompany;
      scope.addTraitPackage = this.addTraitPackage;
      dialog = this.modal.open({
        windowClass: 'product-dialog',
        templateUrl: 'backend/portal/ratings/products/edit-dialog',
        controller: 'Ratings.Controllers.EditProductDialogController',
        scope: scope,
        resolve: {
          'lineups_id': (function(_this) {
            return function() {
              return _this.scope.selected.crop.lineups_id;
            };
          })(this),
          'product': (function(_this) {
            return function() {
              return product;
            };
          })(this)
        }
      });
      return dialog.result.then((function(_this) {
        return function(saved_product) {
          $.extend(product, saved_product);
          _this.recalculateActiveProducts();
          return _this.setProductFullNames();
        };
      })(this));
    };

    SetupDialogController.prototype.activateProduct = function(product) {
      return this.repo.activateProduct(this.scope.selected.crop.lineups_id, product).then((function(_this) {
        return function(response) {
          var ref, ref1, seed_company, trait_package;
          if (((ref = response.status) != null ? ref.type : void 0) !== 'success') {
            _this.showActivationError('Product', true, (ref1 = response.status) != null ? ref1.msg : void 0);
            return;
          }
          product.active = true;
          if (response.data.seed_company != null) {
            seed_company = _.head(_.filter(_this.scope.seed_companies, {
              id: response.data.seed_company.id
            }));
            if (seed_company != null) {

            } else {
              _this.scope.seed_companies.push(response.data.seed_company);
            }
          }
          if (response.data.trait_package != null) {
            trait_package = _.head(_.filter(_this.scope.trait_packages, {
              id: response.data.trait_package.id
            }));
            if (trait_package != null) {
              trait_package.active = true;
            } else {
              _this.scope.trait_packages.push(response.data.trait_package);
            }
          }
          _this.recalculateActiveProducts();
          return _this.setProductFullNames();
        };
      })(this))["catch"]((function(_this) {
        return function(response) {
          var ref;
          return _this.showActivationError('Product', true, (ref = response.status) != null ? ref.msg : void 0);
        };
      })(this));
    };

    SetupDialogController.prototype.deactivateProduct = function(product) {
      return this.repo.deactivateProduct(this.scope.selected.crop.lineups_id, product).then((function(_this) {
        return function(response) {
          var ref, ref1;
          if (((ref = response.status) != null ? ref.type : void 0) !== 'success') {
            _this.showActivationError('Product', false, (ref1 = response.status) != null ? ref1.msg : void 0);
            return;
          }
          product.active = false;
          return _this.recalculateActiveProducts();
        };
      })(this))["catch"]((function(_this) {
        return function(response) {
          var ref;
          return _this.showActivationError('Product', false, (ref = response.status) != null ? ref.msg : void 0);
        };
      })(this));
    };

    SetupDialogController.prototype.recalculateActiveProducts = function() {
      var i, j, k, len, len1, len2, ref, ref1, ref2, results, sc, tmt, tp;
      ref = this.scope.seed_companies;
      for (i = 0, len = ref.length; i < len; i++) {
        sc = ref[i];
        sc.num_active = _.filter(this.scope.products, {
          seed_companies_id: sc.id,
          active: true
        }).length;
      }
      ref1 = this.scope.trait_packages;
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        tp = ref1[j];
        tp.num_active = _.filter(this.scope.products, {
          trait_packages_id: tp.id,
          active: true
        }).length;
      }
      ref2 = this.scope.treatments;
      results = [];
      for (k = 0, len2 = ref2.length; k < len2; k++) {
        tmt = ref2[k];
        results.push(tmt.num_active = _.filter(this.scope.products, (function(_this) {
          return function(product) {
            return product.active && _.includes(product.treatment_options, tmt.id);
          };
        })(this)).length);
      }
      return results;
    };

    SetupDialogController.prototype.setProductFullNames = function() {
      var i, len, p, ref, results, sc, tp;
      ref = this.scope.products;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        p = ref[i];
        sc = _.head(_.filter(this.scope.seed_companies, {
          id: p.seed_companies_id
        }));
        tp = _.head(_.filter(this.scope.trait_packages, {
          id: p.trait_packages_id
        }));
        results.push(p.full_name = ((sc != null ? sc.name : void 0) + " " + p.name + " " + (tp != null ? tp.suffix : void 0)).trim());
      }
      return results;
    };

    return SetupDialogController;

  })(DialogController);

}).call(this);
